import { ValidatorFn, Validators } from '@angular/forms';
import { isNumeric } from '@shared/core/utils';
import { BaseControl } from './base';
import { FormFieldSerializedValue } from '../index';
import { integerValidator } from '../integer-validator';

export class NumberControl extends BaseControl {
  unserializeValue(): any {
    return isNumeric(this.field.value) ? Number(this.field.value) : null;
  }

  serializeValue(formControlValue: any): FormFieldSerializedValue {
    return isNumeric(formControlValue) ? Number(formControlValue) : null;
  }

  protected getKnownValidators(): { [key: string]: (...args: any[]) => ValidatorFn } {
    return {
      min: Validators.min,
      max: Validators.max,
      integer: () => integerValidator,
    };
  }
}
